export default "__VITE_ASSET__Cu_Zb4h5__"